'use client';

import Script from 'next/script'
import getConfig from "service/getConfig";

import {
  CAT_FUNCTIONALITY, CAT_ANALYTICS, CAT_NECESSARY,
  SERVICE_ANALYTICS_STORAGE
} from './ConsentCookie/ConsentCookieDefinitions.js'

const {gtmId: GTM_MEASUREMENT_ID} = getConfig();

export default function GoogleAnalytics(){

    return (
        <>
          {/* <Script
              strategy="beforeInteractive"
              src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}/> */}
          <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','${GTM_MEASUREMENT_ID}');`}
          </script>
          <script id='tagmanagerload'>
            {`window.dataLayer = window.dataLayer || [];
                  function gtag(){dataLayer.push(arguments);}
                  const dateTime = new Date();
                  gtag('js', dateTime);
                  gtag('config', '${GTM_MEASUREMENT_ID}', {
                     page_path: window.location.pathname,
                   });
                   gtag('consent', 'default', {
                     ['${CAT_NECESSARY}']: 'granted',
                     ['${CAT_ANALYTICS}']: 'denied',
                     ['${CAT_FUNCTIONALITY}']: 'denied',
                     ['${SERVICE_ANALYTICS_STORAGE}']: 'denied',
                   });`}
          </script>
          <Script
              strategy="lazyOnload"
              src={"https://www.google.com/recaptcha/api.js"}
          />
        </>
)}